import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user_2oYfG",
  "use": "user_2oYfG-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"user_2oYfG\">\n    <circle cx=\"12\" cy=\"8\" r=\"3\" stroke=\"currentColor\" fill=\"none\" />\n    <path d=\"M6,20c0-4,12-4,12,0\" stroke=\"currentColor\" fill=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol